import React from 'react';
import { BsTwitter } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { TiSocialLinkedinCircular } from 'react-icons/ti';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <BsTwitter onClick={() => { window.location.replace('https://www.twitter.com/abidullah_786'); }} />
    </div>
    <div>
      <FaGithub onClick={() => { window.location.replace('https://www.github.com/abidullah786'); }} />
    </div>
    <div>
      <TiSocialLinkedinCircular onClick={() => { window.location.replace('https://www.linkedin.com/in/abidullah786/'); }} />
    </div>
  </div>
);

export default SocialMedia;
